import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  suppliersCategories: null,
};

const slice = createSlice({
  name: "suppliers",
  initialState: initialState,
  currentSupplier: null,
  reducers: {
    setSuppliersState: (state, action) => {
      Object.keys(action.payload).forEach((k) => {
        state[k] = action.payload[k];
      });
    },
  },
});

export const reducer = slice.reducer;

export const setSuppliersState = (data) => async (dispatch) => {
  dispatch(slice.actions.setSuppliersState(data));
};
